import Swiper from 'swiper';
import 'swiper/css/bundle';

const charactersLeftArrow = document.getElementById('charactersLeftArrow');
const charactersRightArrow = document.getElementById('charactersRightArrow');

let charactersSwiper;

charactersSwiper = new Swiper('.characters-swiper-container', {
  direction: 'horizontal',
  loop: false,
  centeredSlides: true,
  slidesPerView: 1,
  slidesPerGroup: 1,
  initialSlide: 0,
  spaceBetween: 16,
  speed: 500,
  allowTouchMove: true,
  grabCursor: true,
  watchOverflow: true,
  breakpoints: {
    1440: {
      centeredSlides: false,
      slidesPerView: 'auto',
      spaceBetween: 32,
    },
  },

  on: {
    init(swiper) {
      document
        .querySelector('.characters-swiper-container')
        .classList.add('show');
      updateCharactersArrows(swiper);
    },
    slideChange(swiper) {
      updateCharactersArrows(swiper);
    },
    reachEnd(swiper) {
      updateCharactersArrows(swiper);
    },
    reachBeginning(swiper) {
      updateCharactersArrows(swiper);
    },
  },
});

updateCharactersArrows(charactersSwiper);

function updateCharactersArrows(swiper) {
  charactersLeftArrow.disabled = swiper.isBeginning;
  charactersRightArrow.disabled = swiper.isEnd;
}

charactersLeftArrow.addEventListener('click', () => {
  charactersSwiper.slidePrev();
});

charactersRightArrow.addEventListener('click', () => {
  charactersSwiper.slideNext();
});
